import { useEffect } from 'react'
import { ILog, IAlarm } from '@obvious.tech/constellation'

import api, { TApiError, TApiResponse, TEntity } from 'src/utils/api'
import { TLoadable } from 'src/utils/Loadable'

const getLogsByAlarmID = async ({
  id,
  token,
}: {
  id: string
  token?: string
}): Promise<TApiResponse<Array<TEntity<ILog>>, TApiError>> =>
  await api.getResourcesWithFilters<TEntity<ILog>>('alarms/api/Log')({
    filters: [['alarmId', api.Filter.Eq, id]],
    token,
  })

export type TLogs = Array<TEntity<ILog>>

export type TUseLogsResult = TLoadable<TLogs, TApiError>

export type TProps = {
  alarm: TEntity<IAlarm>
  authorization?: string
}

const useLogs = ({ alarm, authorization }: TProps): TUseLogsResult => {
  const [alarmLogs, getAlarmLogs] = api.useApiAction(getLogsByAlarmID)

  useEffect(() => {
    return getAlarmLogs({
      id: alarm.id,
      token: authorization,
    })
  }, [alarm, authorization, getAlarmLogs])

  return alarmLogs
}

export default useLogs
